import { format, parse, parseISO, isValid } from 'date-fns';

/**
 * Pipe/Utility function to format date strings to backend format (yyyy-MM-dd)
 */
export const formatDate = (dateTimeStr: string) => {
  if (dateTimeStr) {
    const date = parseISO(dateTimeStr);
    return format(date, 'yyyy-MM-dd');
  }

  return "";
};

/**
 * Pipe/Utility function to format date-time strings to (yyyy-MM-dd HH:mm)
 */
export const formatDateTime = (dateTimeStr: string) => {
  if (dateTimeStr) {
    const date = parseISO(dateTimeStr);
    return format(date, 'yyyy-MM-dd HH:mm');
  }

  return "";
};

/**
 * Pipe/Utility function to format date strings to user-friendly display format (dd/MM/yyyy)
 * This is the standard format for displaying dates to users
 */
export const formatDateDisplay = (dateStr: string | null | undefined): string => {
  if (!dateStr) return '-';
  
  try {
    // Try to parse from ISO format first
    let date = parseISO(dateStr);
    
    // If not valid, try parsing from yyyy-MM-dd format
    if (!isValid(date)) {
      date = parse(dateStr, 'yyyy-MM-dd', new Date());
    }
    
    if (isValid(date)) {
      return format(date, 'dd/MM/yyyy');
    }
    
    return '-';
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};

export const unFormatDateTime = (dateStr: string) => {
  if (dateStr) {
    const parsedDate = parse(dateStr, 'yyyy-MM-dd', new Date());
    return parsedDate.toISOString();
  }

  return "";
};
